//import "isomorphic-fetch";
//import "@babel/polyfill";
//require('es6-promise/auto');
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import React, {Component} from 'react';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
//import MomentUtils from 'material-ui-pickers/utils/moment-utils';
//import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider';
//import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import {Redirect, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl'
import 'react-big-calendar/lib/less/styles.less';
import 'styles/bootstrap.scss'
import 'styles/app.scss';
import 'styles/app-rtl.scss';
import defaultTheme from './themes/defaultTheme';
import AppLocale from '../lngProvider';
import Intercom, {IntercomAPI} from 'react-intercom';
import LogRocket from 'logrocket';

import MainApp from 'app/index';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';

import { getProfile, listServices } from 'api/index.js';
import { setApiUrl } from 'actions/Api';
import {loginWithFacebook} from 'api/index';

import MyAuthContainer from 'myContainers/MyAuthContainer/index'
import MyPrivateRoute from 'myContainers/MyPrivateRoute/index'
//import MyLoader from 'myComponents/MyLoader/index';

class App extends Component {

    constructor(props) {
        super(props);

        console.log("version ",VERSION, " started");

        // set API url
//        var apiUrl = "https://api.dns-net.de/custportal/v1/";
        var apiUrl = "https://test.api.dns-net.de/custportal/v1/";
        this.fbAppId = "293629281419095"; // localhost:3000
        if (process.env.NODE_ENV==="production") {
            // we are in production mode (from node point of view), so check if we are running on the
            // test or the production server
            this.rollbarEnvironment = window.location.hostname==="mein.dns-net.de"?"production":"test";
//            apiUrl = window.location.hostname==="mein.dns-net.de"?"https://api.dns-net.de/custportal/v1/":"https://api.dns-net.de/custportal/v1/";
            apiUrl = window.location.hostname==="mein.dns-net.de"?"https://api.dns-net.de/custportal/v1/":"https://test.api.dns-net.de/custportal/v1/";
            this.fbAppId = window.location.hostname==="mein.dns-net.de"?"486439381873060":"1987946611495999";
        }
        this.props.dispatch(setApiUrl(apiUrl));

        if (this.rollbarEnvironment === "production") {
            LogRocket.init('dnsnet/my-webclient');
        }

    }

    componentDidMount() {
        // facebook code
        window.fbAsyncInit = function() {
            window.FB.init({
                appId      : this.fbAppId,
                cookie     : true,
                xfbml      : true,
                version    : 'v3.1'
            });

            window.FB.Event.subscribe('auth.statusChange', function (response) {
                console.log('FB: auth.statusChange fired');
                if (response.status === "connected") {
                    console.log('FB: facebook logged in: ', response);
                    FB.api('/me?fields=email,name,first_name,last_name', function(response2) {
                        console.log(JSON.stringify(response2));

                        // connected, so continue to login
                        this.props.dispatch(loginWithFacebook(this.props.apiUrl, this.props.session, { userId: response.authResponse.userID, email: response2.email, name: response2.name, firstName: response2.first_name, lastName: response2.last_name, accessToken: response.authResponse.accessToken }));
                    }.bind(this));
                } else {
                    console.log('FB: facebook logged out');
                }
            }.bind(this));
/*
            FB.getLoginStatus(function(response) {
                if (response.status === "connected") {
                    // already logged in

                }
            }.bind(this));
*/
        }.bind(this);

        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    }

//    componentWillUpdate(nextProps, nextState) {
//        console.log('componentWillUpdate old ', this.props, ' new ', nextProps);
//    }

    componentDidUpdate(prevProps, prevState, snapshot) {
//        console.log('componentDidUpdate old ',prevProps,' new ',this.props);
        if (
            // apiUrl changed and we have a session
            ((prevProps.apiUrl !== this.props.apiUrl) && (this.props.session) && (this.props.apiUrl)) ||
            // or session changed and we have an apiUrl
            ((prevProps.session !== this.props.session) && (this.props.apiUrl) && (this.props.session))
         ) {
            // so refresh network data
//            console.log('MY: fetching data from api (url=',this.props.apiUrl,' session=',this.props.session);
            this.props.dispatch(getProfile(this.props.apiUrl,this.props.session));
            this.props.dispatch(listServices(this.props.apiUrl,this.props.session));
            IntercomAPI('update', {
                new_session: true
            });
        }

        // if logged in user changed, update intercom
        if (
            (prevProps.login != this.props.login) || 
            (prevProps.customerHash != this.props.customerHash) || 
            (prevProps.firstName != this.props.firstName) || 
            (prevProps.lastName != this.props.lastName) ||
            (prevProps.city != this.props.city) ||
            (prevProps.mobile != this.props.mobile) ||
            (prevProps.contactPermission != this.props.contactPermission) ||
            (prevProps.customer != this.props.customer)
        ) {
            /*
            console.log('MY: intercom update to ',{
                name: this.props.firstName + ' ' + this.props.lastName,
                email: this.props.login,
                Ort: this.props.city,
                unsubscribed_from_emails: !this.props.contactPermission,
                phone: this.props.mobile,
                user_id: this.props.customer,
                user_hash: this.props.customerHash,
                Kundennummer: this.props.customer,
            });*/
            IntercomAPI('update', {
                name: this.props.firstName + ' ' + this.props.lastName,
                email: this.props.login,
                Ort: this.props.city,
                unsubscribed_from_emails: !this.props.contactPermission,
                phone: this.props.mobile,
                user_id: this.props.customer,
                user_hash: this.props.customerHash,
                Kundennummer: this.props.customer,
            });

            LogRocket.identify(this.props.login, {
                name: this.props.firstName + ' ' + this.props.lastName,
                email: this.props.login,
              
                // Add your own custom user variables here, ie:
                customerNumber: this.props.customer,
                appVersion: VERSION
            });
        }
    }

    render() {
        const {match, location, locale, isDirectionRTL} = this.props;
        if (location.pathname === '/') {
            return ( <Redirect to={'/app/welcome'}/> );
        }
        let applyTheme = createMuiTheme(defaultTheme);
        if (isDirectionRTL) {
            applyTheme.direction = 'rtl';
            document.body.classList.add('rtl')
        } else {
            document.body.classList.remove('rtl');
            applyTheme.direction = 'ltr';
        }

        const user = {
        };

        const currentAppLocale = AppLocale[locale.locale];
        return (
            /*
            <MuiThemeProvider theme={applyTheme}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <IntlProvider
                        locale={currentAppLocale.locale}
                        messages={currentAppLocale.messages}>
                        <RTL>
                                <div className="app-main">
                                    <Intercom appID="buisy67f" { ...user } />
                                    <MyAuthContainer />
                                    <Switch>
                                        <MyPrivateRoute path={`${match.url}app`}>
                                            <MainApp />
                                        </MyPrivateRoute>
                                        <Route
                                            component={asyncComponent(() => import('components/Error404'))}/>
                                    </Switch>
                                </div>
                        </RTL>
                    </IntlProvider>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
            */
            <MuiThemeProvider theme={applyTheme}>
                    <IntlProvider
                        locale={currentAppLocale.locale}
                        messages={currentAppLocale.messages}>
                        <RTL>
                                <div className="app-main">
                                    <Intercom appID="buisy67f" { ...user } />
                                    <MyAuthContainer />
                                    <Switch>
                                        <MyPrivateRoute path={`${match.url}app`}>
                                            <MainApp />
                                        </MyPrivateRoute>
                                        <Route
                                            component={asyncComponent(() => import('components/Error404'))}/>
                                    </Switch>
                                </div>
                        </RTL>
                    </IntlProvider>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = function(state){
    return {
        sideNavColor: state.settings.sideNavColor,
        locale: state.settings.locale,
        isDirectionRTL: state.settings.isDirectionRTL,
        apiUrl: state.api.url,
        session: state.api.session,
        apiIsUpdating: state.api.isUpdating,

        login: state.profile && state.profile.login,
        customer: state.profile && state.profile.customer,
        customerHash: state.profile && state.profile.customerHash,
        firstName: state.profile && state.profile.contactData && state.profile.contactData.firstName,
        lastName: state.profile && state.profile.contactData && state.profile.contactData.lastName,
        city: state.profile && state.profile.contactData && state.profile.contactData.city,
        mobile: state.profile && state.profile.contactData && state.profile.contactData.mobile,
        contactPermission: state.profile && state.profile.contactPermission,
    }
};

export default connect(mapStateToProps)(App);

